import { Component, input, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { GroupValidationModule } from 'src/lib/templates/layout/group-validation/group-validation.module';
import { FormControlWrapper } from 'src/lib/types/forms.def';
import { hasValue } from 'src/lib/utilities/compare';
import { IPaginationTable } from '../../core/pagination-table.interface';

export interface PaginationTableSearchSaveEdit {
	newName: string;
	selectedSave: string;
}

@Component({
	selector: 'ae-pagination-table-search-save-modal',
	templateUrl: './pagination-table-search-save-modal.component.html',
	styleUrls: ['./pagination-table-search-save-modal.component.scss'],
	imports: [
		FormsModule,
		GroupValidationModule,
		NgSelectModule,
		ReactiveFormsModule,
	],
})
export class PaginationTableSearchSaveModalComponent<T> implements OnInit {
	readonly pgTable = input.required<IPaginationTable<T>>();

	public currentSearches: string[];
	public editForm: FormGroup<FormControlWrapper<PaginationTableSearchSaveEdit>>;

	constructor(
		public activeModal: NgbActiveModal,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.currentSearches = this.pgTable().userPreferences.savedSearches.map(
			(x) => x.name,
		);

		this.editForm = this.fb.group<
			FormControlWrapper<PaginationTableSearchSaveEdit>
		>(
			{
				newName: new FormControl(null, (control: FormControl<string>) => {
					if (control.value == null) {
						return null;
					} else if (
						this.currentSearches.find(
							(x) =>
								x.toLowerCase().trim() === control.value.toLowerCase().trim(),
						)
					) {
						return { duplicate: true };
					} else return null;
				}),
				selectedSave: new FormControl(null),
			},
			{
				validators: [
					(
						group: FormGroup<FormControlWrapper<PaginationTableSearchSaveEdit>>,
					) => {
						if (
							!hasValue(group.controls.newName.value) &&
							!hasValue(group.controls.selectedSave.value)
						) {
							return {
								required: 'Either a new name or a current name is required',
							};
						}

						return null;
					},
				],
			},
		);
	}

	public dismiss = () => {
		this.activeModal.dismiss();
	};

	public save = () => {
		const value = this.editForm.value;
		const name = (value.selectedSave || value.newName).trim();
		this.activeModal.close(name);
	};
}
